<template>
  <div class="overflow-hidden">
    <div>
      <div
        v-if="!submitSuccess"
      >
        <p class="font-weight-bold mb-2 mb-md-4 mt-0 mt-md-2">
            Nützliche Antworten auf interessierte Fragen
        </p>
        <ul class="mb-4">
            <li>Struktur des Kurses</li>
            <li>Kursinhalte</li>
            <li>Ablauf der Prüfung </li>
            <li class="mb-0">Zertifikatslevel</li>
        </ul>
        <div>
          <div class="form-row mt-3">
            <div
              class="form-group col"
              :class="{ 'form-group--error': $v.formData.anrede.$error }"
            >
              <div
                class="d-inline-flex justify-content-center align-items-center"
              >
                <label class="mb-0 mr-3">Anrede wählen</label>
                <label class="check-container mb-0"
                  >Frau
                  <input
                    type="radio"
                    name="salutation"
                    id="salutation_frau"
                    value="Frau"
                    v-model.trim.lazy="$v.formData.anrede.$model"
                  />
                  <span class="checkmark"></span>
                </label>
                <label class="check-container mb-0"
                  >Herr
                  <input
                    type="radio"
                    name="salutation"
                    id="salutation_herr"
                    value="Herr"
                    v-model.trim.lazy="$v.formData.anrede.$model"
                  />
                  <span class="checkmark"></span>
                </label>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div
              class="form-group col-md-6"
              :class="{ 'form-group--error': $v.formData.vorname.$error }"
            >
              <label for="firstname">Vorname</label>
              <input
                type="text"
                class="form-control"
                id="firstname"
                v-model.trim.lazy="$v.formData.vorname.$model"
              />
            </div>
            <div
              class="form-group col-md-6"
              :class="{ 'form-group--error': $v.formData.nachname.$error }"
            >
              <label for="lastname">Nachname</label>
              <input
                type="text"
                class="form-control"
                id="lastname"
                v-model.trim.lazy="$v.formData.nachname.$model"
              />
            </div>
          </div>
          <div class="form-row">
            <div
              class="form-group col"
              :class="{ 'form-group--error': $v.formData.email.$error }"
            >
              <label for="email">E-Mail*</label>
              <input
                type="email"
                class="form-control"
                id="email"
                v-model.trim.lazy="$v.formData.email.$model"
                required
              />
              <div class="validation-error" v-if="!$v.formData.email.required">
                Bitte ausfüllen
              </div>
              <div class="validation-error" v-if="!$v.formData.email.email">
                E-Mail ist ungültig
              </div>
            </div>
          </div>
          <div
            class="form-row"
            :class="{ 'form-group--error': $v.formData.terms.$error }"
          >
            <div class="form-group col-12 m-0">
              <div
                class="d-inline-flex justify-content-center align-items-center h-100 check-container"
              >
                <label for="terms" class="checkmark">
                  <small class="font-weight-bold">
                    Durch die Anforderung des Whitepapers bestätigen Sie, 
                    dass Sie auch in Zukunft weitere Informationen von uns zu 
                    dem Thema erhalten wollen. Diese Einwilligung erfolgt freiwillig 
                    und kann von Ihnen jederzeit widerrufen werden. Wir verarbeiten 
                    Ihre Daten datenschutzkonform. Details finden Sie in unserer 
                    <a href="/datenschutzerklaerung" target="_blank" class="text-black">Datenschutzerklärung</a>.*
                  </small>
                  <input
                    type="checkbox"
                    id="terms"
                    value="accepted"
                    v-model.trim.lazy="$v.formData.terms.$model"
                    required
                    style="width: 10px"
                  />
                  <span class="checkmark not-radio"></span>
                </label>
              </div>
            </div>
            <div
              class="validation-error form-group col-12"
              v-if="!$v.formData.terms.mustBeTrue"
            >
              Bitte ausfüllen
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col">
              <p class="my-2 small">*Pflichtfelder</p>
            </div>
          </div>
          <div v-if="Object.keys(errors).length" class="w-100">
            <div v-for="(v, k) in errors" :key="k">
              <p v-for="error in v" :key="error" class="text-danger lh-1 mb-0">
                <small class="font-weight-bold lh-1" v-html="error"></small>
              </p>
            </div>
          </div>
          <div class="mb-3 mb-md-0">
            <button
              id="sendData"
              @click.prevent="sendData"
              class="btn btn-primary text-uppercase font-weight-bold"
              :disabled="isLoading"
            >
              JETZT Downloaden
            </button>
            <svg v-if="isLoading"
              style="
                position: absolute;
                margin-top: -20px;
                margin-left: 20px;
              "
              id="loading"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              width="80px"
              height="80px"
              viewBox="0 0 40 40"
              enable-background="new 0 0 40 40"
              xml:space="preserve"
            >
              <path
                opacity="0.2"
                fill="#000"
                d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946
  s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634
  c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"
              />
              <path
                fill="#000"
                d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0
  C22.32,8.481,24.301,9.057,26.013,10.047z"
              >
                <animateTransform
                  attributeType="xml"
                  attributeName="transform"
                  type="rotate"
                  from="0 20 20"
                  to="360 20 20"
                  dur="0.5s"
                  repeatCount="indefinite"
                />
              </path>
            </svg>
          </div>
        </div>
      </div>
      <div v-if="submitSuccess" class="p-0">
        <h3>Vielen Dank!</h3>
        <p>
          Ihre Anforderung weiterer Informationen zur Weiterbildung zum
          FROSIO Insulation Inspector ist bei uns eingegangen.
        </p>
        <p>
          <strong>Wir haben von Ihnen folgende Daten erhalten</strong>
        </p>
        <p>Vorname: {{ formData.vorname }}<br>
        Nachname: {{ formData.nachname }}<br>
        E-Mail: {{ formData.email }}
        </p>
        <p>Sie erhalten in Kürze eine E-Mail, in der Sie Ihre E-Mail-Adresse bestätigen müssen.</p>
        <p>Viele Grüße<br />Ihr SLV Team</p>
      </div>
    </div>
  </div>
</template>

<script>
import { required, email, helpers } from "vuelidate/lib/validators";
const phoneNumber = helpers.regex("telefon", /^[0-9\+\(\)\-\s]+$/);
const mustBeTrue = (value) => value === true;
const isHerrOrFrau = (value) => value == "Herr" || value == "Frau";
export default {
  data() {
    return {
      errors: {},
      isLoading: false,
      submitSuccess: false,
      formData: {
        anrede: "",
        vorname: "",
        nachname: "",
        email: "",
        phone: "",
        terms: null,
      },
    };
  },
  methods: {
    async sendData() {
      let _this = this;
      _this.errors = {};
      _this.$v.$touch();      
      if (_this.$v.$invalid) {
        _this.submitStatus = "ERROR";
        return;
      } else {
        if (!_this.isLoading) {
          _this.isLoading = true;
          // Recaptcha
          // Execute reCAPTCHA and get the token
          const token = await new Promise((resolve, reject) => {
              grecaptcha.ready(function () {
              grecaptcha.execute(window.recaptchaKey, { action: 'submit' }).then(token => {
                  resolve(token);
              });
              });
          });

          const url = "/api/whitepaper-submit";
          const data = {
            email: _this.formData.email,
            vorname: _this.formData.vorname,
            nachname: _this.formData.nachname,
            phone: _this.formData.phone,
            anrede: _this.formData.anrede,
            terms: _this.formData.terms,
            formular: "Whitepaper",
            token
          };
          axios
            .post(url, data)
            .then((response) => {
              if (response.data.success) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                  whitepaperConversion: "1",
                  event: "whitepaperConversion",
                });
                _this.submitSuccess = true;
              } else {
                _this.errors = { errors: ["Versuchen Sie es bitte erneut."] };
              }
              _this.isLoading = false;
            })
            .catch(function (error) {
              if (error.response.data.errors) {
                  _this.errors = error.response.data.errors;
                }
                _this.isLoading = false;
            });
        }
      }
    },
  },
  validations: {
    formData: {
      anrede: {
        // isHerrOrFrau,
      },
      vorname: {
        // required,
      },
      nachname: {
        // required,
      },
      email: {
        required,
        email,
      },
      phone: {
        phoneNumber,
      },
      terms: {
        mustBeTrue,
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import "resources/sass/_variables.scss";

h2 {
  font-size: 2.5rem;
}

.success-checkmark {
  width: 80px;
  height: 115px;
  margin: 0 auto;
}

.success-checkmark > .check-icon {
  width: 80px;
  height: 80px;
  position: relative;
  border-radius: 50%;
  box-sizing: content-box;
  border: 4px solid $blue;
}

.success-checkmark > .check-icon::before {
  top: 3px;
  left: -2px;
  width: 30px;
  transform-origin: 100% 50%;
  border-radius: 100px 0 0 100px;
}

.success-checkmark > .check-icon::after {
  top: 0;
  left: 30px;
  width: 60px;
  transform-origin: 0 50%;
  border-radius: 0 100px 100px 0;
  animation: rotate-circle 4.25s ease-in;
}

.success-checkmark > .check-icon::after,
.success-checkmark > .check-icon::before {
  content: "";
  height: 100px;
  position: absolute;
  background: #f7f7f7;
  transform: rotate(-45deg);
}

.success-checkmark > .check-icon > .icon-line {
  height: 5px;
  background-color: $blue;
  display: block;
  border-radius: 2px;
  position: absolute;
  z-index: 10;
}

.success-checkmark > .check-icon > .line-tip {
  top: 46px;
  left: 14px;
  width: 25px;
  transform: rotate(45deg);
  animation: icon-line-tip 0.75s;
}

.success-checkmark > .check-icon > .line-long {
  top: 38px;
  right: 8px;
  width: 47px;
  transform: rotate(-45deg);
  animation: icon-line-long 0.75s;
}

.icon-circle {
  top: -4px;
  left: -4px;
  z-index: 10;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  position: absolute;
  box-sizing: content-box;
  border: 4px solid rgba(0, 155, 219, 0.5);
}

.icon-fix {
  top: 8px;
  width: 5px;
  left: 26px;
  z-index: 1;
  height: 85px;
  position: absolute;
  transform: rotate(-45deg);
  background-color: #f7f7f7;
}

@keyframes rotate-circle {
  0% {
    transform: rotate(-45deg);
  }

  5% {
    transform: rotate(-45deg);
  }

  12% {
    transform: rotate(-405deg);
  }

  100% {
    transform: rotate(-405deg);
  }
}

@keyframes icon-line-tip {
  0% {
    width: 0;
    left: 1px;
    top: 19px;
  }

  54% {
    width: 0;
    left: 1px;
    top: 19px;
  }

  70% {
    width: 50px;
    left: -8px;
    top: 37px;
  }

  84% {
    width: 17px;
    left: 21px;
    top: 48px;
  }

  100% {
    width: 25px;
    left: 14px;
    top: 45px;
  }
}

@keyframes icon-line-long {
  0% {
    width: 0;
    right: 46px;
    top: 54px;
  }

  65% {
    width: 0;
    right: 46px;
    top: 54px;
  }

  84% {
    width: 55px;
    right: 0;
    top: 35px;
  }

  100% {
    width: 47px;
    right: 8px;
    top: 38px;
  }
}

/* Success Checkmark */

svg path,
svg rect {
  fill: $orange;
}

.link {
  color: $black;
  font-weight: 700;
  text-decoration: none;
}

.link > img {
  margin-right: 5px;
  transition: all 0.2s ease-in-out;
}

.link:active > img {
  margin-right: 8px;
}

/* The container */
.check-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: 25px;
  margin-right: 10px;
  position: relative;
  user-select: none;
  height: 20px;
}

/* Hide the browser's default radio button */
.check-container input {
  position: absolute;
  opacity: 0;
  display: none;
  cursor: pointer;
}

/* Create a custom radio button */
.check-container input[type="radio"] ~ .checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #f7f7f7;
  border-radius: 50%;
  border: 1px solid $black;
}

.check-container input[type="checkbox"] ~ .checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #f7f7f7;
  border: 1px solid $black;
  border-radius: 0.25rem;
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  opacity: 0;
  transition: all 0.2s ease-in-out;
}

.checkmark:hover {
  cursor: pointer;
}

/* Show the indicator (dot/circle) when checked */
.check-container input:checked ~ .checkmark:after {
  opacity: 1;
}

#banner_thankyou {
  /* background-color: #a2c7e6; */
  background: linear-gradient(90deg, #93bcde 50%, #a2c7e6 50%);
}

@media (max-width: 767px) {
  h2 {
    font-size: 2rem;
  }
}
/* Create a custom radio button */
.check-container input[type="radio"]~.checkmark {
    position: absolute;
    top: calc(50% - 10px);
    left: 0;
    height: 20px;
    width: 20px;
    background-color: #f7f7f7;
    border-radius: 50%;
    border: 1px solid $black;
    cursor:pointer;
}

.check-container input[type="checkbox"]~.checkmark {
    position: absolute;
    top: calc(50% - 10px);
    left: 0;
    height: 20px;
    width: 20px;
    background-color: #f7f7f7;
    border: 1px solid $black;
    border-radius: 0.25rem;
    cursor:pointer;
}
</style>
